/** Canonical storage is cm / kg. Display converts when the selected unit is ft or st. */
function fromCanonical(value: number, unit: string): number {
    if (unit === "ft") return value / 30.48;
    if (unit === "st") return value / 6.35029318;
    return value;
}

/**
 * `entry_values_view.value` prefers text_value, so measurements otherwise show only "cm" / "kg".
 */
export function formatMeasurementResult(
    numberValue: number | null | undefined,
    unit: string | null | undefined
): string {
    if (numberValue == null || Number.isNaN(Number(numberValue))) {
        return unit?.trim() ?? "";
    }

    const unitLabel = unit?.trim() ?? "";
    const display = unitLabel ? fromCanonical(Number(numberValue), unitLabel) : Number(numberValue);
    const rounded = Math.round(display * 100) / 100;
    return unitLabel ? `${rounded} ${unitLabel}` : String(rounded);
}
